import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {styles} from "./../../styles/documents";
import {withStyles} from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import Typography from "@material-ui/core/Typography";
import {configEduLevelsTranslateMap} from "../../config/edu_levels";
import {getContestsLevelsEduUnique} from "@helpers/functions";
import {withTranslation} from "react-i18next";

class RequirementsDocuments extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {zajavl, requirementsDocuments, t} = this.props;
        const contests = zajavl.contests;
        const contestsLevelsEduUnique = getContestsLevelsEduUnique(contests);
        const requirementsDocumentsFiltered = requirementsDocuments.filter(requirementsDocument => contestsLevelsEduUnique.indexOf(requirementsDocument.id) !== -1);
        let requirementsDocumentsFilteredUnique = [];
        requirementsDocumentsFiltered.forEach(document => {
            let isFind = false;
            requirementsDocumentsFilteredUnique.forEach(documentUnique => {
                if (document.value === documentUnique.value) {
                    isFind = true;
                    documentUnique.ids.push(document.id);
                }
            });
            if (!isFind) {
                requirementsDocumentsFilteredUnique.push({ids: [document.id], value: document.value});
            }
        });
        requirementsDocumentsFilteredUnique.forEach(document => {
            let labels = [];
            document.ids.forEach(id => {
                labels.push(t(configEduLevelsTranslateMap[id]));
            });
            document.label = labels.join('; ');
        });
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {t('document_requirements')}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        {requirementsDocumentsFilteredUnique.length > 0
                            ? requirementsDocumentsFilteredUnique.map(document => {
                                return (
                                    <Grid item xs={12} key={document.value}>
                                        <Typography variant="subtitle1">
                                            {document.label}
                                        </Typography>
                                        {document.value
                                            ? <div dangerouslySetInnerHTML={{ __html: document.value }} />
                                            : <Typography variant="body1">{t('no_requirements')}</Typography>}
                                    </Grid>
                                )
                            })
                            : <Grid item xs={12}><Typography variant="body1">{t('no_requirements')}</Typography></Grid>}
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

function mapStateToProps(state) {
    return {
        requirementsDocuments: state.requirementsDocuments,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(RequirementsDocuments));
